module.exports = __webpack_public_path__ + "static/covid-dashboard-3e9bba48b9c5558f27d14e80320bc4fe.jpg";